export const createEmptyProductRecord = () => ({
  code: "",
  convFactor: "",
  description: "",
  id: 0,
  listPrice: "",
  sizeCode: null,
  uomBig: "",
  uomSmall: "",
});

// CSV column mapping for different file formats
export const CSV_PRODUCT_COLUMN_MAPPINGS = {
  standard: {
    code: "PRD_CD",
    description: ("PRD_DESC1" || "").trim() || null,
    sizeCode: "SIZECODE" || null,
    uomSmall: "UOM_CD_SMALL" || null,
    uomBig: "UOM_CD_BIG" || null,
    convFactor: "CONV_FACTOR",
    listPrice: "UOM_LISTPRC",
  },
};

// Validation rules for invoice records
export const PRODUCT_VALIDATION_RULES = {
  code: {
    required: true,
    minLength: 1,
    maxLength: 50
  },
  description: {
    required: false,
    minLength: 1,
    maxLength: 100,
  },
  listPrice: {
    required: false,
    min: 0,
    type: "number",
  },
  sizeCode: {
    required: false,
  },
  uomSmall: {
    required: false,
  },
  uomBig: {
    required: false,
  },
  convFactor: {
    required: false,
  },
};
